import { callApi } from '@/helpers/api';
import CONFIG from '@/config/global';

const { api: { HOST, GET_CHANNELS_BY_GENRE_ID } } = CONFIG;

// Get channels that have the given genre [id] as a listed genre
const getChannelsByGenreId = ({
  id, params, isServer = false
}) => {
  return callApi({
    url: HOST(GET_CHANNELS_BY_GENRE_ID) + GET_CHANNELS_BY_GENRE_ID.replace(':genre_id', id),
    queryParams: { ...params },
    isServer
  });
};

export default getChannelsByGenreId;